import { formatDateToSubmit } from 'utilities/datesAndTimes';

import PaymentPlanForm from '../PaymentPlanForm';
import PaymentsCalculatorCard from '../PaymentsCalculatorCard';
import {
  PRECO_STEPS,
  setNextStep,
  setPrecoPaymentDetails,
  setPrecoSchedule,
  usePrecoState,
} from './precoState';

const PrecoPaymentPlanDetailsStep = () => {
  const { offer, cadence, startDate, durationMonths, schedule } =
    usePrecoState();

  const maxDurationMonths = offer.durationMonths;

  const handlePaymentDetails = ({ cadence, startDate, duration }) => {
    setPrecoPaymentDetails({
      cadence,
      startDate: startDate ? formatDateToSubmit(startDate) : null,
      durationMonths: duration,
    });
  };

  return (
    <PaymentPlanForm
      formName="precoPaymentDetailsForm"
      initialCadence={cadence}
      initialStartDate={startDate}
      initialDuration={durationMonths ?? maxDurationMonths}
      balance={offer.settlementBalance}
      expirationDate={offer.expirationDate}
      maxDurationMonths={maxDurationMonths}
      durationLabel="Enter Plan Duration (in months)"
      durationRequired={true}
      setPaymentDetails={handlePaymentDetails}
      setSchedule={setPrecoSchedule}
      onSubmit={() => setNextStep(PRECO_STEPS.REVIEW_SCHEDULE)}
      renderEstimatedPayments={(queryLoading) => (
        <PaymentsCalculatorCard
          loadingQuery={queryLoading}
          balance={offer.settlementBalance}
          expirationDate={offer.expirationDate}
          startDate={startDate}
          cadence={cadence}
          schedule={schedule}
          durationMonths={durationMonths ?? maxDurationMonths}
        />
      )}
    />
  );
};

export default PrecoPaymentPlanDetailsStep;
